import { FC, useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  CheckboxControlledMui,
  EmailTemplate,
  MessagesDisplayContainer,
} from "@ryde/controls";
import {
  apiDataFetchingLandingAtom,
  ClalLoginStepFormFieldsEnum,
  landingMessagesAtom,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepLoginClal } from "./use-step-login.clal";

export const StepLoginClal: FC = () => {
  const { methods, handleLogin, isContinueCanBeApply } = useStepLoginClal();
  const { watch, setValue } = methods;
  const [searchParams, setSearchParams] = useSearchParams();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();
  const acceptTermsWatchField = watch(ClalLoginStepFormFieldsEnum.AcceptTerms);
  const rydeAcceptTermsWatchField = watch(
    ClalLoginStepFormFieldsEnum.rydeAcceptTerms,
  );

  useEffect(() => {
    if (searchParams) {
      setSearchParams("");
    }
  }, [searchParams, setSearchParams]);

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={e => e.preventDefault()}>
        <h1 className="landing-title">
          {t("landing.login.title")}
          <br />
          {t("landing.login.subTitle")}
        </h1>

        <div className="landing-form-field landing-form-field__email">
          <label htmlFor={ClalLoginStepFormFieldsEnum.Email}>
            {t("landing.formLabel.email")}*
          </label>
          <EmailTemplate
            uniqueAttrId={ClalLoginStepFormFieldsEnum.Email}
            name={ClalLoginStepFormFieldsEnum.Email}
          />
        </div>

        <div className="landing-form-field">
          <div className="landing-accept-terms">
            <CheckboxControlledMui
              width={16}
              height={16}
              checked={acceptTermsWatchField ?? false}
              setCheckedToggle={() =>
                setValue(
                  ClalLoginStepFormFieldsEnum.AcceptTerms,
                  !acceptTermsWatchField,
                )
              }
            />
            <span className="custom-label">
              {t("landing.formLabel.clalDisclaimer")}
            </span>
          </div>
        </div>

        <div className="landing-form-field">
          <div className="landing-accept-terms">
            <CheckboxControlledMui
              width={16}
              height={16}
              checked={rydeAcceptTermsWatchField ?? false}
              setCheckedToggle={() =>
                setValue(
                  ClalLoginStepFormFieldsEnum.rydeAcceptTerms,
                  !rydeAcceptTermsWatchField,
                )
              }
            />
            <span className="custom-label">
              {t("landing.formLabel.clalRideDisclaimer")}
            </span>
          </div>
        </div>

        <MessagesDisplayContainer
          serverMessages={landingMessages?.messages}
          type={landingMessages?.type}
        />

        <ContinueButton
          loading={isApiLoading}
          disabled={!isContinueCanBeApply}
          onClick={handleLogin}
        />

        <div className="landing-container-footer">
          <div className="landing-container-footer-logo">
            <img
              className="landing-logo__img"
              src={RASTER_LANDINGS.RideLogoPNG}
              alt="Ryde logo"
              width="120"
              height="51"
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
